import APMOverview from './overview.json';

import InstancesFilter from './widget/filter/instances.json';
import ServicesFilter from './widget/filter/services.json';
import InstancesStatusFilter from './widget/filter/status.json';

import AvgResponseTime from './widget/avg-response-time.json';
import Status from './widget/status.json';
import Calls from './widget/calls.json';
import ErrorCalls from './widget/error-calls.json';
import InstancesGrid from './widget/instances-grid.json';
import Instances from './widget/instances.json';

import TotalCalls from './widget/total_calls.json';
import TotalErrors from './widget/total_errors.json';

export default [
  InstancesFilter,
  ServicesFilter,
  InstancesStatusFilter,
  AvgResponseTime,
  Status,
  Calls,
  ErrorCalls,
  InstancesGrid,
  Instances,
  TotalCalls,
  TotalErrors,

  // Dashboards
  APMOverview,
];
